/*global Modernizr, console */
/*jslint browser:true */

(function() {
  'use strict';

  const dd_pepperoni_rolls = document.querySelectorAll('.dd-pepperoni-roll-animation');
  const footer_pizza_animation = document.getElementById('footer-pizza-animation');

  const handler = function() {
    if(dd_pepperoni_rolls) {
      dd_pepperoni_rolls.forEach((dd_pepperoni_roll) => {
        if(percentageSeen(dd_pepperoni_roll) > 30) {
          dd_pepperoni_roll.classList.add('open');
        } else {
          dd_pepperoni_roll.classList.remove('open');
        }
      });
    }

    if(footer_pizza_animation) {
      if(percentageSeen(footer_pizza_animation) > 60) {
        footer_pizza_animation.classList.add('in-view');
      } else {
        footer_pizza_animation.classList.remove('in-view');
      }
    }
  };

  addEventListener('DOMContentLoaded', handler, false);
  addEventListener('load', handler, false);
  addEventListener('scroll', handler, false);
  addEventListener('resize', handler, false);

  function percentageSeen(element) {
    // Get the relevant measurements and positions
    const viewportHeight = window.innerHeight;
    const bounds = element.getBoundingClientRect();
    const elementOffsetTop = bounds.y;
    const elementHeight = element.offsetHeight;

    // Calculate percentage of the element that's been seen
    const distance = viewportHeight - elementOffsetTop;
    const percentage = Math.round(
      distance / ((elementHeight) / 100)
    );

    // Restrict the range to between 0 and 100
    return Math.min(100, Math.max(0, percentage));
  }
})();